module.exports = __webpack_public_path__ + "1d538a26654a001e0b68704c45f9023e.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/logo.png
// module id = 883
// module chunks = 0